import { apiClient } from './client';

export interface GlpiSyncResult {
  ok: boolean;
  message: string;
  total: number;
  creados: number;
  actualizados: number;
  sinEmpleadoEnGoogle: number;
}

export interface GoogleSyncResult {
  ok: boolean;
  message: string;
}

/** Dispara la sincronización con GLPI (síncrono: devuelve los conteos). */
export async function forceGlpiSync(): Promise<GlpiSyncResult> {
  const { data } = await apiClient.post<GlpiSyncResult>('/sync/glpi/force');
  return data;
}

/** Dispara la sincronización con Google Workspace (corre en segundo plano). */
export async function forceGoogleSync(): Promise<GoogleSyncResult> {
  const { data } = await apiClient.post<GoogleSyncResult>('/sync/google-workspace/force');
  return data;
}

export interface EstadoSyncGoogle {
  enProgreso: boolean;
  fase: 'inactivo' | 'conectando' | 'listando' | 'procesando' | 'completado' | 'error';
  totalUsuarios: number;
  procesados: number;
  creados: number;
  actualizados: number;
  omitidosSinCedula: number;
  omitidosDuplicados: number;
  iniciadoEn: string | null;
  terminadoEn: string | null;
  mensaje: string | null;
  log: string[];
}

/** Estado/progreso de la sincronización con Google Workspace (para polling en vivo). */
export async function obtenerEstadoSyncGoogle(): Promise<EstadoSyncGoogle> {
  const { data } = await apiClient.get<EstadoSyncGoogle>('/sync/google-workspace/estado');
  return data;
}
